import { h } from 'preact'

import { ContentType } from '@insided/shared/utils/contentType'
import OpenEscalationButton from './OpenEscalationButton'

interface Props {
  isProductboardNoteCreationEnabled: boolean
  isZendeskTicketEscalationEnabled: boolean
  isSalesforceCaseEscalationEnabled: boolean
  isFreshdeskTicketEscalationEnabled: boolean
  isIntercomCreateConversationEnabled: boolean
  contentType: ContentType
  topicId: number
  trashed: boolean
  isReply: boolean
}

const OpenEscalationOptions = (props: Props) => {
  const {
    isZendeskTicketEscalationEnabled,
    isSalesforceCaseEscalationEnabled,
    isProductboardNoteCreationEnabled,
    isFreshdeskTicketEscalationEnabled,
    isIntercomCreateConversationEnabled,
    trashed,
    contentType,
    topicId,
    isReply
  } = props
  const showEscalation = isZendeskTicketEscalationEnabled || isProductboardNoteCreationEnabled || isSalesforceCaseEscalationEnabled || isFreshdeskTicketEscalationEnabled || isIntercomCreateConversationEnabled
  const id = `${topicId}:${contentType}:${isReply.toString()}`
  return (
    showEscalation
      ? <div className='button__escalated_container'>
        {isFreshdeskTicketEscalationEnabled && <OpenEscalationButton
            isEnabled={isFreshdeskTicketEscalationEnabled && !trashed}
            imageName='freshdesk-s'
            title='Freshdesk ticket'
            id={id}
            escalationType='freshdesk'
                                               />}
        {isZendeskTicketEscalationEnabled && <OpenEscalationButton
          isEnabled={isZendeskTicketEscalationEnabled && !trashed}
          imageName='zendesk-s'
          title='Zendesk ticket'
          id={id}
          escalationType='zendesk'
                                             />}
        {isProductboardNoteCreationEnabled && <OpenEscalationButton
          isEnabled={isProductboardNoteCreationEnabled && !trashed}
          imageName='productboard-s'
          title='Productboard note'
          id={id}
          escalationType='productboard'
                                              />}
        {isSalesforceCaseEscalationEnabled && <OpenEscalationButton
          isEnabled={isSalesforceCaseEscalationEnabled && !trashed}
          imageName='salesforce-s'
          title='Salesforce case'
          id={id}
          escalationType='salesforce'
                                              />}
        {isIntercomCreateConversationEnabled && <OpenEscalationButton
          isEnabled={isIntercomCreateConversationEnabled && !trashed}
          imageName='intercom-s'
          title='Intercom conversation'
          id={id}
          escalationType='intercom'
                                                />}
      </div>
      : null
  )
}

export default OpenEscalationOptions
